module.exports = __webpack_public_path__ + "media/images/flags/lr-367719d10d657691695089f0c8525f2a.svg";